import React from 'react'
import { Member } from 'memberships/schema'
import InfoRow, { InfoRowContainer } from 'uiComponents/infoRow'
import Section from '../../common/section/section'
import './member.scss'
import { formatISOString } from 'utils/dates'
import { DateFormats } from 'utils/dates'
import placeholderPhoto from 'images/member-photo-placeholder.png'
import PermissionRequired from 'admin/permissionRequired'
import { useTranslation } from 'translations'

const calculateAge = (dateOfBirth: string) => {
    const birthDate = new Date(dateOfBirth)
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const monthDiff = today.getMonth() - birthDate.getMonth()
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--
    }
    return age
}

interface MemberSectionProps {
    member?: Member
    isLoading?: boolean
    accountSlug: string
    openUpdateModal: () => void
}

const MemberSection = ({ member, openUpdateModal, isLoading, accountSlug }: MemberSectionProps) => {
    const { t } = useTranslation()
    let birthDateText = '-'
    if (member?.dateOfBirth) {
        const formattedDateOfBirth = formatISOString(member.dateOfBirth, DateFormats.EXTRA_LONG_DATE)
        const age = calculateAge(member.dateOfBirth)
        const ageText = t('memberships.membershipDetailsPanel.member.age', { count: age })
        birthDateText = t('memberships.membershipDetailsPanel.member.dateOfBirthWithAge', { date: formattedDateOfBirth, age: ageText })
    }

    return (
        <Section
            className="member"
            title={
                <>
                    <h5 className="section-title">{t('memberships.membershipDetailsPanel.member.title')}</h5>
                    <PermissionRequired name="edit_orders" accountSlug={accountSlug}>
                        <span className="update-info" onClick={openUpdateModal}>
                            {t('memberships.membershipDetailsPanel.member.updateInformation')}
                        </span>
                    </PermissionRequired>
                </>
            }
        >
            <a
                className="member-photo"
                href={member?.photo}
                target="_blank"
                rel="noreferrer"
                style={{ backgroundImage: `url(${placeholderPhoto})` }}
            >
                {member?.photo && <img src={member?.photo} alt={t('memberships.membershipDetailsPanel.member.photoAlt')} />}
            </a>
            <InfoRowContainer loading={isLoading}>
                <InfoRow label={t('memberships.membershipDetailsPanel.member.firstName')} className="first-name" value={member?.firstName} />
                <InfoRow label={t('memberships.membershipDetailsPanel.member.lastName')} className="last-name" value={member?.lastName} />
                <InfoRow label={t('memberships.membershipDetailsPanel.member.dateOfBirth')} className="date-of-birth" value={birthDateText} />
                <InfoRow label={t('memberships.membershipDetailsPanel.member.phoneNumber')} className="phone-number" value={member?.phoneNumber} />
                <InfoRow label={t('memberships.membershipDetailsPanel.member.streetAddress')} className="street-address" value={member?.streetName} />
                <InfoRow label={t('memberships.membershipDetailsPanel.member.postCode')} className="post-code" value={member?.zipCode} />
                <InfoRow label={t('memberships.membershipDetailsPanel.member.city')} className="city" value={member?.city} />
                <InfoRow label={t('memberships.membershipDetailsPanel.member.country')} className="country" value={member?.country} />
            </InfoRowContainer>
        </Section>
    )
}

export default MemberSection
